import $ from "../libs/jquery-3.5.1.min.js";
import "../libs/css_browser_selector.js";
import {Anim} from "./Anim.js";

export class MainApp {

	constructor() {
		this.anim = new Anim()
		this.anim.attach();
	}

}

